import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { UiNodeSpec } from './UiNodeSpec';

export const comparisonNumberUiNodeSpec: UiNodeSpec<'comparisonNumber'> = {
    requiredSockets: () => ({
        conditionallyRequired: [],
        required: [ 'output', 'input1', 'input2' ],
    }),
    cfg: () => ({ controlValues: { not: false, operation: '=' }, id: getUID(), kind: 'comparisonNumber', disabled: false }),
    controls: getNodeCfg => {
        return {
            not: { cfg: { kind: 'boolean', label: 'Not' }, nodeCfg: getNodeCfg(), value: getNodeCfg().controlValues.not },
            operation: ({
                cfg: {
                    items: [
                        { label: '=', value: '=' },
                        { label: '>', value: '>' },
                        { label: '>=', value: '>=' },
                        { label: '<', value: '<' },
                        { label: '<=', value: '<=' },
                    ],
                    kind: 'selection',
                    label: 'Operation',
                },
                nodeCfg: getNodeCfg(),
                value: getNodeCfg().controlValues.operation,
            }),
        };
    },
    inputs: nodeCfg => ({
        input1: ({
            control: ({
                cfg: {
                    kind: 'number',
                    nullable: true,
                },
                nodeCfg,
                nullable: true,
                value: nodeCfg.socketDefaults?.inputs?.input1,
            }),
            socket: 'number',
            label: 'Input 1',
        }),
        input2: ({
            control: ({
                cfg: {
                    kind: 'number',
                    nullable: true,
                },
                nodeCfg,
                nullable: true,
                value: nodeCfg.socketDefaults?.inputs?.input2,
            }),
            socket: ('number'),
            label: 'Input 2',
        }),
    }),
    kindLabel: 'Number Comparison',
    nodeCategory: 'conditional',
    outputs: () => ({ output: { socket: 'boolean', label: 'Output' } }),
    validator: () => true,
};
